import TopNav from "@/components/module/TopNav.vue";

export default {
    home: {
        home_1: "气候变化是当今世界共同面临的最大挑战之一。在应对气候变化的全球努力中，国际碳市场及绿色低碳供应链发挥着极其重要的作用。完善碳排放核算核查机制，对促进国际碳市场建设，加快打造国际绿色低碳供应链具有十分重要的意义。"
        , home_2: "为促进碳核算核查技术提升与业务发展，加快碳核算核查技术和经验的传播，提升各方碳核算核查能力，共同提高全球范围内碳排放数据的透明性、准确性、完整性、可比性、一致性和可信性，促进国际碳市场建设，加快打造国际绿色低碳供应链，在中国质量认证中心有限公司倡议下，由中国质量认证中心有限公司、南德认证检测（中国）有限公司、韩国品质财团、SCS Global Services 、中国检验认证集团欧洲测试有限公司等 5 家核查机构，依照西班牙法律正式注册成立国际碳核算核查理事会。在理事会筹备成立过程中，上海挪华威认证有限公司、中国航空集团有限公司、中国绿发投资集团有限公司、国家电投集团综合智慧能源有限公司、正泰集团研发中心（上海）有限公司、大金空调（上海）有限公司、碳治论坛研究院有限公司等 7 家组织给予了重要贡献和大力支持，被视为重要贡献单位，依照本章程，将被优先邀请成为成员单位。"
        , home_3: "技术委员会"
        , home_4: "政策解读"
        , home_5: "最新最前沿的双碳政策解读"
        , home_6: "ICAVC发布"
        , home_7: "查看章程",
        home_8: "前往查看",
        home_9: "查看更多"
    },

    about: {
        about_1: "标准引领：",
        about_2: "促进国际范围内碳核查机构和企业之间的交流合作，参与国际国内碳领域政策对话，建立与政府主管部门、产业链链长和相关国际机构沟通的渠道，争取成为有关国际组织或区域组织的成员代表或观察员，积极参与相关国际标准规则制修订，在碳排放核算核查机制、标准规则、政策等方面反映理事会统一立场和观点。"
        , about_3: "多边互认",
        about_4: "建立理事会成员间发展合作机制，通过研究探索、实践应用以及对话磋商等方式，参与国际国内碳市场碳税机制建设，推动企业碳资产管理能力建设，提升企业国际碳壁垒应对能力，努力推进国际间不同碳市场机制下核算核查结果双多边互认，助力国际碳市场建设。",
        about_5: "转型重塑：",
        about_6: "发挥理事会成员的行业领军优势和产业链供应链链主作用，带动产业链供应链上下游企业碳管理能力建设和绿色低碳转型，协同打造绿色低碳供应链，促进跨行业碳数据与价值传递，努力推进供应链碳足迹国际互认，助力各方双碳目标实"
        , about_7: "理事会主要活动",
        about_8: "组织召开理事会成员大会年度会议，会议内容包括理事会年度计划、年度总结、新成员入会、管理层换届等。",
        about_9: "组织召开理事会年度技术交流会议，会议主题内容涵盖国际碳领域相关政策、技术、热点议题等。",
        about_10: "组织开展国内国际碳核算核查交流合作、专题研究、标准规则制定、技术咨询、成果推广、成果宣传、培训和能力建设等活动。",
        about_11: "发布理事会及其成员在碳核算核查及理事会各项工作进展和成果",
        about_12: "政策技术委员会",
        about_13: "碳市场/碳税技术委员",
        about_14: "供应链/碳足迹技术委员会",
        about_15: "推广宣传技术委员会",
        aboutPolicy_1: {
            name: "马宁慧",
            corporation: "国家电投集团综合智慧能源有限公司",
            position: "碳资产事业部副总经理"
        },
        aboutPolicy_2: {
            name: "吕学都",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会主任；国家气候中心原副主任；亚开行原首席气候变化专家"
        },
        aboutPolicy_3: {
            name: "孙冰",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会执行主任；碳治论坛研究院董事长；复旦大学特聘研究员"
        },
        aboutPolicy_4: {
            name: "阿里·切希",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会学术委员；昆士兰大学建筑、设计与规划学院 (ADP) 院长；Springer城市可持续发展（美国）系列丛书主编"
        },
        aboutPolicy_5: {
            name: "包存宽",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会副主任；复旦大学教授、博导；复旦大学城市环境管理研究中心主任"
        },
        aboutPolicy_6: {
            name: "罗伯特",
            corporation: "SCS Global Services",
            position: "大中华区业务发展与战略总监"
        },
        aboutPolicy_7: {
            name: "叶晨",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会 ｜ 碳治论坛研究院 研究员；剑桥大学制造研究院博士"
        },
        aboutPolicy_8: {
            name: "杨草宇",
            corporation: "正泰集团研发中心（上海）有限公司",
            position: "双碳技术工程师"
        },
        aboutPolicy_9: {
            name: "成嘉",
            corporation: "国家电投集团综合智慧能源有限公司",
            position: "碳资产事业部双碳业务经理"
        },
        aboutPolicy_10: {
            name: "王子歆",
            corporation: "国家电投集团综合智慧能源有限公司",
            position: "碳资产事业部专员"
        },
        aboutPolicy_11: {
            name: "奚 悦",
            corporation: "CQC",
            position: "双碳研究院"
        },
        aboutPolicy_12: {
            name: "李志青",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会学术委员；复旦大学经济学院党委副书记；复旦大学绿色金融研究中心执行主任"
        },
        aboutPolicy_13: {
            name: "韩建军",
            corporation: "CQC",
            position: "双碳研究院主管"
        },
        aboutPolicy_14: {
            name: "李美庭",
            corporation: "KFQ",
            position: "部门长"
        },
        aboutPolicy_15: {
            name: "金京爱",
            corporation: "KFQ",
            position: "负责人"
        },
        aboutPolicy_16: {
            name: "耿泽茜",
            corporation: "SCS Global Services",
            position: "全生命周期分析师"
        },
        aboutPolicy_17: {
            name: "骆婷",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会秘书；碳治论坛研究院咨询经理"
        },
        aboutPolicy_18: {
            name: "张丽欣",
            corporation: "CQC",
            position: "产品认证六部副经理、双碳研究院副院长"
        },
        aboutPolicy_19: {
            name: "李依纯",
            corporation: "正泰集团研发中心（上海）有限公司",
            position: "双碳技术工程师"
        },
        aboutPolicy_20: {
            name: "李錫原",
            corporation: "KFQ",
            position: "部门长"
        },
        aboutPolicy_21: {
            name: "陆 遥",
            corporation: "CQC",
            position: "双碳研究院"
        },
        aboutPolicy_22: {
            name: "孙悦",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会秘书；碳治论坛研究院咨询经理"
        },
        aboutPolicy_23: {
            name: "唐燕琪",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会副秘书长；碳治论坛研究院理事；复旦大学研究生导师；碳启城科技联合创始人"
        },
        aboutPolicy_24: {
            name: "魏联晓",
            corporation: "正泰集团研发中心（上海）有限公司",
            position: "双碳技术工程师"
        },
        aboutPolicy_25: {
            name: "陈芸蕾",
            corporation: "中英碳治委员会",
            position: "中英碳治委员会秘书；碳治论坛研究院 品牌经理"
        },
        aboutPolicy_26: {
            name: "晁亮亮",
            corporation: "正泰集团研发中心（上海）有限公司",
            position: "碳中和技术研发负责人"
        },
    }
    ,
    policyTechnology: {
        target: {
            target_1: "工作目标",
            target_2: "碳核算与核查体系完善",
            target_3: "推动建立和完善国际碳核算和核查体系，提高碳数据的准确性和可靠性。",
            target_4: "政策跟踪与影响评估",
            target_5: "紧密跟踪国际碳政策的最新动态，评估这些政策对碳市场和碳核算核查的影响。",
            target_6: "碳市场发展与优化",
            target_7: "促进全球碳市场的健康发展，优化交易机制，提高市场效率。",
            target_8: "政策解读与建议",
            target_9: "深入解读相关政策，为理事会成员提供业务发展建议和指导，以适应政策变化。",
            target_10: "低碳技术与创新推广",
            target_11: "推广低碳技术和创新，支持绿色清洁能源技术的发展，以实现全球范围内低碳转型。",
            target_12: "技术发展趋势监测",
            target_13: "监测评估碳领域的技术发展趋势，特别是那些可能对碳核算和碳市场产生重大影响的技术。",
            target_14: "国际合作与交流",
            target_15: "加强合作与交流，共享最佳实践，努力推动全球碳减排努力。",
            target_16: "政策参与与支持",
            target_17: "积极参与国际碳领域的政策制定，为政策制定者提供专业支持和建议。",
        },
        content: {
            content_1: "工作内容",
            content_2: "政策研究与分析",
            content_3: "定期收集和分析国际碳政策的最新动态。",
            content_4: "评估政策变化对行业和市场的影响，并提供相应的业务指导。",
            content_5: "技术趋势监测",
            content_6: "跟踪碳领域的技术创新和发展趋势。",
            content_7: "识别可能对政策和市场产生重大影响的关键技术。",
            content_8: "政策建议与指导",
            content_9: "为理事会成员提供政策解读和业务发展建议。",
            content_10: "参与制定和优化碳领域的相关政策。",
            content_11: "市场机制建设",
            content_12: "参与国际碳市场的建设和完善，包括交易机制和监管框架。",
            content_13: "推动国际碳市场的健康发展，提高市场效率和透明度。",
            content_14: "国际合作与交流",
            content_15: "加强与其他国际组织和同行的合作与交流。",
            content_16: "分享最佳实践，推动全球碳减排努力。",
            content_17: "能力建设与培训",
            content_18: "组织培训和研讨会，提升成员单位和相关人员的专业能力。",
            content_19: "促进知识共享和经验交流。",
            content_20: "项目与活动组织",
            content_21: "策划和执行与碳政策和技术相关的项目和活动。",
            content_22: "促进政策和技术的实际应用和实施。",
            content_23: "信息发布与传播",
            content_24: "定期发布政策和技术的最新信息。",
            content_25: "通过各种渠道传播重要的政策和技术动态。",
        }
    },
    carbonMarketTax: {
        workTarget: "工作目标",
        carbonMarketTax_target: {
            carbonMarketTax_target_1: "中长期目标",
            carbonMarketTax_target_2: "促进国际范围内碳核查机构和企业之间的交流合作；",
            carbonMarketTax_target_3: "国际国内碳市场及碳税领域政策研究；",
            carbonMarketTax_target_4: "建立与政府主管部门和相关国际机构沟通的渠道；",
            carbonMarketTax_target_5: "积极参与相关国际标准规则制修订；",
            carbonMarketTax_target_6: "参与国际国内碳市场碳税机制建设；",
            carbonMarketTax_target_7: "近期目标",
            carbonMarketTax_target_8: "主导及编制标准2项。发挥联盟技术委员会的智库功能和专家作用，组织研究提出一批碳市场/碳税相关的标准制定方案；完成编制并发布2项；",
            carbonMarketTax_target_9: "支持企业低碳数字化转型。支持企业利用系统/平台开展数据计算和管理工作，完成相关报告/表格的数字化交付；",
            carbonMarketTax_target_10: "建立与政府主管部门和相关国际机构沟通的渠道；",
            carbonMarketTax_target_11: "组织和参与国内外技术交流会议2场每年；",
        },
        workContent: "工作内容",
        carbonMarketTax_content: {
            carbonMarketTax_content_1: "根据ICAVC的章程制定碳市场/碳税技术委员会年度工作计划。 参与建立与政府主管部门/相关国内外机构在碳市场/碳税方面沟通交流的渠道，参与国际国内碳市场/碳税机制建设。 负责研究和跟进碳市场/碳税相关政策/法规/技术的进展，并形成成果文件。 主导和参与编制碳市场/碳税相关标准并发布。 负责组织理事会内外部在碳市场/碳税方面的培训和技术交流论坛/宣传/活动等。 负责对接理事会成员及相关行业企业在碳市场/碳税方面遇到的困难，形成意见建议/解决方案。",
        }
    },
    supplyChainCarbonFootprint: {
        workTarget: "工作目标",
        supplyChainCarbonFootprint_target: {
            supplyChainCarbonFootprint_target_1: "中长期目标",
            supplyChainCarbonFootprint_target_2: "逐步形成供应链和碳足迹领域的ICAVC标准体系，实现标准和结果在ICAVC内部的互认，助力ICAVC成员单位及相关方绿色低碳供应链建设能力和碳足迹管理能力，有效应对国际贸易碳壁垒，提升国际竞争力；",
            supplyChainCarbonFootprint_target_3: "逐步推进供应链和碳足迹领域ICAVC标准被相关国家或地区、国际组织、相关供应链企业的采用，提高ICAVC在供应链和碳足迹领域的影响力；",
            supplyChainCarbonFootprint_target_4: "通过技术委员会及ICAVC理事会的共同努力，助力推进国际供应链和碳足迹的标准与结果互认；",
            supplyChainCarbonFootprint_target_5: "近期目标",
            supplyChainCarbonFootprint_target_6: "制定并发布供应链和碳足迹领域ICAVC标准2-3项，并得到ICAVC成员单位的试点应用；",
            supplyChainCarbonFootprint_target_7: "推动ICAVC标准的外部引用或采用，提高ICAVC标准影响力。",
        },
        workContent: "工作内容",
        supplyChainCarbonFootprint_Content: {
            supplyChainCarbonFootprint_Content_1: "跟踪国内外供应链和碳足迹相关政策、方法学、标准等发展动态，开展供应链和碳足迹发展趋势分析，寻找供应链/碳足迹领域标准、数据、培训等需求；",
            supplyChainCarbonFootprint_Content_2: "针对供应链、碳足迹领域标准化需求，联合理事会成员单位及外部优质资源，开展供应链、碳足迹领域相关标准制定工作；",
            supplyChainCarbonFootprint_Content_3: "推进ICAVC供应链/碳足迹领域相关标准的应用，包括ICAVC会员单位使用，外部商业使用，以及转化为国际标准、相关国家标准等，促进标准的国际化和互认；",
            supplyChainCarbonFootprint_Content_4: "开展供应链碳足迹相关政策、标准、规范等方面培训和宣传活动，提高成员单位在供应链管理、碳足迹管理等方面自有管理能力和对外服务能力，提升ICAVC国际影响力。",
        }
    },
    publicityPromotion: {
        workTarget: "工作目标",
        workTarget_data: {
            workTarget_data_1: "品牌建设和传播",
            workTarget_data_2: "推动全球碳核算与核查标准的普及并促进相关技术的应用和落地，提升ICAVC全球品牌可见度和影响力，树立具有国际影响力的碳核算核查机构的权威形象。",
            workTarget_data_3: "会员招募",
            workTarget_data_4: "利用ICAVC的品牌影响力吸引企业、高校、研究机构等成为会员，在行业内外积极宣传会员服务的独特优势，提升会员价值的感知，并针对企业、科研机构、政府部门、环保组织、碳核算及管理咨询公司等，设定不同的特色会员服务。",
            workTarget_data_5: "传播推广",
            workTarget_data_6: "推广碳核算和核查标准，推动其在各国、各行业的应用；推广全球碳核算、核查的最新技术与标准；推动标准在不同行业、国家的应用与落地，并通过案例分享展示技术成果。",
            workTarget_data_7: "营销和外联",
            workTarget_data_8: "推动与理事会成员、利益相关方以及公众的互动参与，以提升国际碳核算核查理事会（ICAVC）的全球知名度。",
            workTarget_data_9: "跨界合作",
            workTarget_data_10: "增强ICAVC与各界的合作，提升影响力与资源整合能力，通过加强战略伙伴关系合作和促进联合倡议来提升ICAVC的知名度和美誉度。",
            workTarget_data_11: "评估和优化",
            workTarget_data_12: "识别需要改进的部分并实施可以提升营销效果和品牌影响力的策略。",
        },
        workContent: "工作内容",
        workTarget_content: {
            workTarget_content_1: "国际论坛和技术交流",
            workTarget_content_2: "定期举办国际论坛、技术交流会、标准发布会，邀请全球专家、政策制定者、行业领导者参与，讨论碳核算核查技术标准建设、场景应用与未来发展。",
            workTarget_content_3: "标准发布与应用推广",
            workTarget_content_4: "定期发布关于碳核算核查和相关标准的技术成果，传递行业前沿观点。整理并展示各行业应用ICAVC标准实现碳减排目标的成功案例和最佳实践。",
            workTarget_content_5: "跨界合作与技术推广",
            workTarget_content_6: "汇聚全球专家，积极展示ICAVC技术成果，推动国际合作与标准应用，传播绿色转型理念，助力合作品牌和会员获得国际市场认可，并引导更多企业和消费者关注可持续发展。",
        }
    },
    resource: {
        resource_1: "ICAVC发布"
    },
    support: {
        support_policy: {
            support_policy_title: "政策合规与战略咨询",
            support_policy_content: {
                support_policy_content_1: "全球监管导航",
                support_policy_content_2: "动态合规仪表盘",
                support_policy_content_3: "欧盟CBAM税费模拟器",
                support_policy_content_4: "美国清洁竞争法案（CCA）预警系统",
                support_policy_content_5: "中国双碳政策雷达",
                support_policy_content_6: "企业治理升级",
                support_policy_content_7: "董事会碳中和治理框架",
                support_policy_content_8: "ESG报告编制（TCFD/SASB/ISSB兼容版）",
            }
        },
        support_standard: {
            support_standard_title: "标准制定与合规认证",
            support_standard_content: {
                support_standard_content_1: "国际标准制定",
                support_standard_content_2: "碳核算框架开发：ISO 14064定制化扩展服务",
                support_standard_content_3: "交叉认证通道：多国碳市场机制互认解决方案   （欧盟CBAM/中国CCER互认路径）",
            }
        },
        support_technology: {
            support_technology_title: "脱碳技术与解决方案",
            support_technology_content: {
                support_technology_content_1: "碳管理数字化转型",
                support_technology_content_2: "ICAVC-CLOUD平台：实时监测45+行业排放因子库",
                support_technology_content_3: "区块链存证系统：防篡改排放数据链（支持ERC-1155碳资产协议））",
                support_technology_content_4: "定制化脱碳路径",
                support_technology_content_5: "行业专属方案：",
                support_technology_content_6: "制造业：工艺能效优化+绿电采购策略",
                support_technology_content_7: "物流业：多式联运碳优化算法",
                support_technology_content_8: "数据中心：算力碳效对标工具",

            }
        },
        support_Governance: {
            support_Governance_title: "数据治理与研究应用",
            support_Governance_content: {
                support_Governance_content_1: "全球碳数据库",
                support_Governance_content_2: "动态更新：",
                support_Governance_content_3: "200+国家排放因子库",
                support_Governance_content_4: "10,000+产品LCA数据集",
                support_Governance_content_5: "前沿洞察交付",
                support_Governance_content_6: "VIP智享服务：",
                support_Governance_content_7: "月度政策预警报告（多语种版）",
                support_Governance_content_8: "技术成熟度曲线分析（AI预测模型）",
            }
        },
        support_Talent: {
            support_Talent_title: "绿色人才与能力建设",
            support_Talent_content: {
                support_Talent_content_1: "专业人才发展",
                support_Talent_content_2: "认证课程体系：",
                support_Talent_content_3: "碳核算基础方法论",
                support_Talent_content_4: "供应链范围3排放建模",
                support_Talent_content_5: "碳金融衍生品设计",
                support_Talent_content_6: "企业内训工坊",
                support_Talent_content_7: "沉浸式沙盘演练：碳市场交易情景模拟舱",
                support_Talent_content_8: "危机响应训练：碳数据审计突发事件处置",
            }
        }
    },

    News: {
        News_1: "博士志愿者计划",
        News_2: "全球研究项目合作",
        News_3: "联系我们",
    },
    join: {
        join_title: {
            join_title_1: "成为全球气候治理体系的核心构建者"
        },
        join_content: {
            join_content_1: "立刻行动 定义未来",
            join_content_2: "气候治理不是选择题，而是必答题。唯有合作，才能为下一代留下一个宜居的地球。我们期待与您并肩，将雄心转化为行动，将行动转化为影响力。",
        },
        join_us: {
            join_us_title: "加入我们",
            join_us_content: {
                join_us_content_1: "输入您的姓名",
                join_us_content_2: "输入您的单位",
                join_us_content_3: "输入您的邮箱",
                join_us_content_4: "输入您的联系电话",
                join_us_content_5: "扫描二维码填写相关信息加入",
                join_us_content_6: "加入",
            }
        }
    },
    green: {
        target: {
            target_1: "工作目标",
            target_2: "生态规模",
            target_3: "推动建立和完善国际发展50家核心成员单位，覆盖金融机构、产业龙头、专业服务机构。",
            target_4: "认证体系",
            target_5: "制定并发布《ICAVC绿色投融资项目认证标准》，完成100个项目的ICAVC认证。",
            target_6: "资本对接",
            target_7: "促成基于ICAVC认证的跨境绿色投融资规模突破100亿美元。",
            target_8: "上市孵化",
            target_9: "助力30家经ICAVC认证的绿色科技企业进入香港或国际资本市场上市流程。"
        },
    },
    TopNav: {
        TopNav_1: "首页",
        TopNav_2: "关于我们",
        TopNav_3: "技术委员会",
        TopNav_4: "政策技术委员会",
        TopNav_5: "碳市场碳税技术委员会",
        TopNav_6: "供应链碳足迹技术委员会",
        TopNav_7: "宣传推广技术委员会",
        TopNav_8: "资源中心",
        TopNav_9: "服务支持",
        TopNav_10: "新闻与活动",
        TopNav_11: "加入我们",
        TopNav_12: "绿色投融资技术委员会",

    },
    siteFooter: {
        siteFooter_1: "友情链接",
        siteFooter_2: "宣传推广技术委员会",
        siteFooter_3: "碳市场碳税技术委员会",
        siteFooter_4: "政策技术委员会",
        siteFooter_5: "供应链碳足迹技术委员会",
        siteFooter_6: "联系方式",
        siteFooter_7: "联系人",
        siteFooter_8: "邮箱",
        siteFooter_9: "地址",
        siteFooter_10: "秘书处地址",
        siteFooter_11: "联系我们",
        siteFooter_12: "绿色投融资技术委员会",
    },
    relation: {
        relation1: "我们会尽快回复",
        relation2: "您好，请留下您的联系方式，以便在您离线的状态下与您联系。",
        relation3: "联系我们"
    },
    Cookie: {
        cookie_1: "我们想使用cookie以便更好了解您对本网站的使用情况。这将有助于改善您今后访问本网站的体验。关于cookie的使用，请详见我们的",
        cookie_2: "隐私协议",
        cookie_3: "如您点击右侧确认按钮，将视为您同意cookie的使用。",
        cookie_4: "确认",
        cookie_5: "拒绝"
    },
    agreement:{
        title:"Cookie 使用说明",
        title_1:"一、什么是 Cookie？",
        content_1:"Cookie 是网站存在您设备上的小型文本文件，帮助网站记住您的使用信息。",
        title_2:"二、我们如何使用 Cookie？",
        content_2_1:"保证网站基础功能正常运行（如登录状态）；",
        content_2_2:"记录您的偏好（如语言设置），优化使用体验；",
        content_2_3:"统计浏览数据，用于改进网站内容。",
        title_3:"三、Cookie 的管理",
        content_3_1:"您可以通过浏览器设置（如 “隐私与安全” 选项）查看、删除或禁用 Cookie；",
        content_3_2:"禁用部分 Cookie 可能导致网站功能异常。",
        title_4:"四、联系我们",
        content_4_1:'如有疑问，可通过 <span style="color: #2c3e50; font-weight: 500;">[邮箱 / 电话]</span> 联系我们。',
    }

}